import {Record} from 'immutable';
import moment from 'moment';

export default class Token extends Record({
    access_token: null,
    refresh_token: null,
    token_type: null,
    issue_date: null,
    expires_in: null,
    user_id: null,
    accept_header: null,
    permissions: null,
}) {
    /**
     * Indica se token está preenchido.
     *
     * @returns {boolean}
     */
    isBound() {
        return this.access_token !== null &&
            this.refresh_token !== null &&
            this.token_type !== null &&
            this.issue_date !== null &&
            this.expires_in !== null &&
            this.user_id !== null &&
            this.accept_header !== null &&
            this.permissions !== null;
    }

    /**
     * Indica se token expirou.
     *
     * Se não tiver preenchido, retorna undefined
     *
     * @returns {boolean|undefined}
     */
    hasExpired() {
        if (!this.isBound()) return undefined;
        let issueDate = moment(this.issue_date).add(this.expires_in, 's');
        return issueDate.isBefore(moment());
    }
}



// WEBPACK FOOTER //
// src/domain/Token.js